module.exports = __webpack_public_path__ + "d206338a3b8f86d29e85b9d8a68ceeb7.MP3";